export const SYSTEM_PROPERTIES = {
  ENABLE_PROPERTY_ENRICHMENT: 'EnablePropertyEnrichment',
  SHAPE_API_KEY: 'ShapeApiKey',
  STATE_LICENSING_CHECKS_DISABLED: 'StateLicensingChecksDisabled',
  LEAD_CREATION_FIELDS_DISABLED: 'LeadCreationFieldsDisabled',
  PREPARE_DISCLOSURES_WIZARD_DISABLED: 'PrepareDisclosuresWizardDisabled',
  PATH_TO_SUBMISSION_DISABLED: 'PathToSubmissionDisabled',
  ALWAYS_COUNT_SATURDAY_FOR_FUNDING: 'AlwaysCountSaturdayForFunding',
};

export const PropertyDataType = {
  BOOLEAN: 'Boolean',
  INTEGER: 'Integer',
  DECIMAL: 'Decimal',
  STRING: 'String',
  JSON: 'Json',
  GUID: 'Guid',
};

export const SENSITIVE_VALUE_MASK = '••••••••';

export const EMPTIED_CREDENTIAL_MESSAGE =
  'Emptying a saved value does not remove it. Enter a new one to replace it.';

export const STORED_VALUE_HINT = 'A value is saved. Enter a new one to replace it.';

export const INHERITED_VALUE_HINT = 'A global value is inherited. Enter a value to override it.';

export const STORED_PASSWORD_HINT = 'Saved. Re-enter to replace.';
